export default __webpack_public_path__ + "static/media/star-empty.c23557f8.svg";